// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1qQJG","item":"PaymentsMobile_item__wShlZ","label":"PaymentsMobile_label__gIFWt","amount":"PaymentsMobile_amount__3tOFi"};